/**
 * Элемент дерева. Расширение `ListItem`.
 * @typedef {ListItem} TreeItem
 * @property {String} id Идентификатор.
 * @property {String} [text] Текстовое представление.
 * @property {Object} [additional] Дополнительные поля.
 * @property {Array.<TreeItem>} [items] Дочерние элементы.
 */

/**
 * Коллбек, вызываемый на каждой модели при обходе дерева.
 * @callback WalkCallback
 * @param {TreeItem} model Модель текущего узла.
 * @param {Array.<TreeItem>} parents Массив моделей родителей от ближнего к дальнему.
 */

/**
 * Рекурсивно проходит по списку моделей, применяет к каждой модели переданную функцию.
 * @param {Array.<TreeItem>} tree Дерево для обработки.
 * @param {WalkCallback} callback Вызываемая функция.
 * @param {Array.<TreeItem>} [parents] Массив моделей родителей от ближнего к дальнему.
 *     Используется в случаях, когда на вход поступают модели из середины дерева, имеющие своих родителей.
 * @private
 */
function _walkWithParents(tree, callback, parents) {
    const currentParents = parents ? parents.slice() : [];
    tree.forEach((item) => {
        callback(item, currentParents);
        if (item.items && item.items.length) {
            _walkWithParents(item.items, callback, [item].concat(currentParents));
        }
    });
}

/**
 * Рекурсивно проходит по списку моделей, применяет к каждой модели переданную функцию.
 * @param {Array.<TreeItem>} tree Дерево для обработки.
 * @param {WalkCallback} callback Вызываемая функция.
 */
function walk(tree, callback) {
    _walkWithParents(tree, callback);
}

export default {
    walk,
};
